import { GeneralModel } from "./general.model";

export class Service extends GeneralModel {
    name: string;
    id: any;
    code: string;
    vseOracleCode: string;
    numbeR_L_W_H_DIM: any;
    isSub: boolean;
    isReturn: boolean;
    isSend: boolean;
}